export  const checkStatus = {'0': '未审核', '1': '待审核', '2':'审核驳回', '10':'审核通过'}
export  const stepLists = ['选择入驻园区', '填写店铺及服务商资料', '等待审核', '提交审核', '认证公司信息', '签约电子协议', '系统处理其他认证信息', '云商通注册成功'];
